import React, { useEffect, useState } from "react";
import { Card, Typography, Box } from "@mui/material";
import axios from "axios";

import {
    AppWidgetSummary,
    AppCurrentVisits,
} from "../sections/@dashboard/app";

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from "recharts";

export default function ZoneDashboard({ zonaId, width = 800, height = 600 }) {

    const [zone, setZone] = useState(null);
    const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

    // 🔥 BASE dimenzije (tvoj original dizajn)
    const BASE_WIDTH = 800;
    const BASE_HEIGHT = 600;

    const scaleX = width / BASE_WIDTH;
    const scaleY = height / BASE_HEIGHT;
    const scale = Math.min(scaleX, scaleY);

    useEffect(() => {
        if (zonaId) getZone();
    }, [zonaId]);

    const getZone = async () => {
        try {
            const res = await axios.get(`${SERVER_URL}/api/zonas/${zonaId}`);
            setZone(res.data);
        } catch (err) {
            console.log("error");
        }
    };

    if (!zone) return null;

    return (
        <Box
            sx={{
                width,
                height,
                overflow: "hidden"
            }}
        >
            <Box
                sx={{
                    width: BASE_WIDTH,
                    height: BASE_HEIGHT,
                    transform: `scale(${scale})`,
                    transformOrigin: "top left"
                }}
            >
                <Card
                    sx={{
                        backgroundColor: "#002855",
                        color: "#fff",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >

                    {/* HEADER */}
                    <Typography sx={{ ml: 2, mt: 1, fontSize: '1rem', fontWeight: 600 }}>
                        Potrošnja zone po mjesecima
                    </Typography>

                    {/* CONTENT */}
                    <Box
                        sx={{
                            p: 1,
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            height: "100%"
                        }}
                    >

                        {/* 🔥 GORNJI DIO */}
                        <Box sx={{ height: "100%", display: "flex", gap: 1 }}>

                            {/* GRAF */}
                            <Box sx={{ flex: 1 }}>
                                <Card sx={{ backgroundColor: "#001B44", height: "100%" }}>
                                    <Box sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column" }}>

                                        <Typography sx={{ fontSize: '0.8rem', mb: 1 }}>
                                            Potrošnja
                                        </Typography>

                                        <Box sx={{ flex: 1 }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <LineChart data={[
                                                    { name: 'Jan', value: zone.januar },
                                                    { name: 'Feb', value: zone.februar },
                                                    { name: 'Mar', value: zone.mart },
                                                    { name: 'Apr', value: zone.april },
                                                    { name: 'Maj', value: zone.maj },
                                                    { name: 'Jun', value: zone.juni },
                                                    { name: 'Jul', value: zone.juli },
                                                    { name: 'Aug', value: zone.august },
                                                    { name: 'Sep', value: zone.septembar },
                                                    { name: 'Okt', value: zone.oktobar },
                                                    { name: 'Nov', value: zone.novembar },
                                                    { name: 'Dec', value: zone.decembar },
                                                ]}>
                                                    <CartesianGrid stroke="#444" strokeDasharray="3 3" />
                                                    <XAxis dataKey="name" stroke="#fff" />
                                                    <YAxis stroke="#fff" />
                                                    <Tooltip />
                                                    <Line type="monotone" dataKey="value" stroke="#ffeb3b" strokeWidth={2} />
                                                </LineChart>
                                            </ResponsiveContainer>
                                        </Box>

                                    </Box>
                                </Card>
                            </Box>
                        </Box>
                    </Box>
                </Card>
            </Box>
        </Box>
    );
}